import connectFrequentlyBoughtTogether from "instantsearch.js/es/connectors/frequently-bought-together/connectFrequentlyBoughtTogether.js";
import { useConnector } from "../hooks/useConnector.js";
export function useFrequentlyBoughtTogether(props, additionalWidgetProperties) {
  return useConnector(connectFrequentlyBoughtTogether, props, additionalWidgetProperties);
}